module.exports = __webpack_public_path__ + "static/img/NG.6cd77286.svg";